import { PartnerType } from "@/app/utils/partners.enum";
import { streamRequest, StreamOptions } from "../http/sseClient";

export type OfertaPreAprovada = {
  idOferta: string;
  descricaoProduto: string;
  valorSimulacao: number;
  quantidadeParcelas: number;
  valorParcela: number;
  dataAtivacaoBeneficio: string;
  mensagemDataAtivacaoBeneficio: string;
  validadeOferta: string;
  codigoInterno: number;
  codigoSimulacao: string;
};

export type MaxValue = {
  convenioId: number;
  nomeConvenio: string;
  tipoSimulacaoId: number;
  tipoSimulacao: string;
  prazoMaximo: number;
  valorParcelaMaximo: string;
  valorTomadorMaximo: string;
  tipoCliente: string;
};

export type GetOperationsResponse = {
  mensagem: string;
  status: boolean;
  clienteId: string;
  permiteCaptura: boolean;
  permiteCapturaMensagem: string;
  permiteCapturaRefin: boolean;
  permiteCapturaRefinMensagem: string;
  ofertasPreAprovadas?: OfertaPreAprovada[];
  refinRecorrente: {
    possuiAdesao: boolean;
    permiteFazerAdesao: boolean;
  };
  maxValues: MaxValue[];
};

export async function getOperations(cpf: string, options?: StreamOptions) {
  return streamRequest<GetOperationsResponse>({
    method: "GET",
    path: `/crefisa/operations/${cpf}`,
    journey: PartnerType.CREFISA,
    ...options,
  });
}
